<script setup lang="ts">
/**
 * Voile plein écran pendant une opération qui bloque l'outil dessin
 * (chargement du plan, sauvegarde, régénération, épaisseurs de trait, fond
 * du plan) : un message et,
 * au besoin, une action (slot).
 */
defineProps<{ status: string }>();
</script>

<template>
  <div class="canvas-busy-overlay">
    <div class="canvas-busy-content">
      <div class="spinner-border text-light mb-3" role="status">
        <span class="visually-hidden">{{ $t("loading") }}</span>
      </div>
      <div class="canvas-busy-status text-light mb-4">{{ status }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.canvas-busy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  // iOS Safari ignore user-scalable=no : sans ça, un pincement sur le voile
  // zoomerait l'interface HTML autour.
  touch-action: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.canvas-busy-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.canvas-busy-status {
  font-size: 1rem;
  min-height: 1.5rem;
}
</style>
